module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Prologue"
    }
  }, [_c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "pro"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpro"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROLOGUE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Johnson’s Island, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Confederate States of America Officers POW Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_c('i', [_vm._v("July 1865")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T WAS HOT")]), _vm._v(". A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S HOT AS")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULY")]), _vm._v(". W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IPING THE SWEAT FROM HIS")]), _vm._v(" brow, Sergeant Thomas Baker gazed out at the waters of Lake Erie and watched the waves leisurely lap its banks. It was a peaceful sight since the lake was so calm. Its surface was smooth, reminding him of a sparkling pane of glass. For once, not a boat or craft was in sight or in hearing distance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, it was peaceful. Tranquil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So much so that Thomas could almost imagine he was out and about, taking a turn along the shore with a lady friend to enjoy a bit of warm weather. She’d have one delicate hand on his arm, and her hand would be bare, allowing him to admire her soft, pale skin. His goal would be to encourage her to smile at him. And because his intentions weren’t all that good, his next goal would be to pull her closer. Close enough to smell her sweet scent. Close enough to brush his lips along the smooth nape of her neck. Just to see her shiver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stretched his right arm and imagined taking her on an "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("outing in a little rowboat, nothing fancy. Once he rowed them out a ways, he would lay down the oars and encourage her to lean against him. Then there she’d be, trailing her fingertips in the water as the current lazily moved them along. They wouldn’t be hungry or cold. They wouldn’t be afraid of death or pain or rats.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They would simply be at peace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That moment would be perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Baker? What ails you?” a guard called out, his voice as coarse and biting as his accent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thomas didn’t bother to reply. Instead, he knelt down into the mud. Pain shot through his knee as it hit the soggy ground. He ignored it, though. Just as he’d learned to ignore most aches and discomforts over the years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He hadn’t had an easy life. Losing his family at far too young an age had marked him. Fighting battle after battle in this never-ending war had been filled with its own fears and challenges.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But gardening while confined in a prisoner of war camp in the middle of Lake Erie certainly held its own brand of torture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Especially for a man like him who wasn’t finding much success while doing it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In an effort to keep his men occupied, Captain Monroe had somehow managed to talk one of their guards into allowing them to plant the pouch of fruit and vegetable seeds one of the captain’s admirers had sent him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not surprisingly—after all, their guards were a dim-witted, lazy lot—no one could think of a single reason not to let the officer prisoners plant a garden. Looking pleased as punch, the captain had allocated a good section of their yard for the effort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the guards stood by, the captain had a group of them hoeing hard dirt and clay, planting seeds, and carefully watering and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("tending the seedlings as though they were newborn babes. Now the plants had borne fruit, and every afternoon a couple of men knelt in the dirt or mud, fought off grasshoppers and mosquitoes, and weeded.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thomas wasn’t sure why he was continually on weeding detail, but since it was a far sight better than latrine digging, he went about the task without complaint.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He enjoyed being near the water, liked looking out into the expanse of it and letting his thoughts drift like one of the paddle-boats he spied from time to time. It was a gift to look at something so serene while toiling in the soil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Except on days like today, when the humidity rose from Lake Erie like a specter and he was sweating like a racehorse in August. Feeling as though his cotton shirt was suffocating him, he began unbuttoning it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Baker?” the guard called out again. “What are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mentally, Thomas rolled his eyes. The Lord had given Clyde Carson both a big mouth and a small brain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Taking off my shirt!” he said as his fingers worked the buttons. Again mentally, he added his pet name for the guard—"), _c('i', [_vm._v("Taking off my shirt, Clay")]), _vm._v("—on account of the man being so slow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But he had probably said too much, even without the name. Been too free with his tone. It really was no wonder the Yankees had festooned him off in the middle of the Great Lakes. He never had learned to control his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the guard stared at him suspiciously, Thomas held up his arm. “It was getting soiled.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh. All right. But be quick about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like it even mattered whether he stripped quickly or slowly. They had nothing but time to kill on this island.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After he removed his oft-mended shirt, he knelt down again "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("and pulled at a clump of weeds. It was muggy enough that he had to wipe the sweat from his brow every five minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He grunted. When they got out of here, he was going to hightail it back to Texas, back to Fort Worth. He wasn’t sure what he was going to do, but he sure wasn’t ever going to weed again if he could help it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The men around him—his fellow prisoners—grinned at him. One or two even laughed at his grimace. His total dislike of gardening was a constant source of amusement for the lot of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You ever grow anything before, Baker?” Major Ethan Kelly asked from about two yards away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thomas glanced up from his row of string beans to meet the major’s eye.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As usual, their elegant major was handling the chore with ease. He still had on his cotton shirt. It looked clean and fresh. Actually, the only indication of the major’s physical exertions was two neatly rolled sleeves. “No, sir. You?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The major chuckled as he walked over to the next row of plants, then crouched down. “Never. But I’m finding digging in the dirt rather restful.” Fingering the small green clump of tomatoes on one of the vines, he said, “I have a feeling these are going to be the best tomatoes I’ve ever eaten.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I bet they will be . . . if you get to eat them. Old Philly over there is looking like he’s already planning his next meal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Major Kelly sat back on his haunches. “You and your names,” he scoffed. “One day the guards are going to overhear your made-up names for them and you’ll pay for the disrespect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Probably,” Thomas said, agreeing easily. But that was the thing, he supposed. His mouth always had gotten him into trouble. He reckoned it always would, until something happened that taught him to learn from his mistakes once and for all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("But that was no matter. He was already so used to hardship and scrambling for everything that he wasn’t sure how to handle easy days with no hint of despair. Only in his dreams did he act like a gentleman.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, as he remembered the direction of the daydream he’d just had, he reckoned he wasn’t much of a gentleman there either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eager to get back to the task at hand, he moved down his row, pulling weeds and swatting away mosquitoes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he stood up to wipe the back of his neck, Old Philly cackled. “What’s wrong, Sergeant? That scar of yours paining you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stilled. Though he knew he shouldn’t, he traced a finger along the thick, raised line that ran down the back of his neck to a couple of inches above his shoulder blade. Even after all these years, the skin felt sensitive and burned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Old Philly scoffed, “Looks like one of our boys got you good. With what? A bayonet?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Comments like that made Thomas sure they were being guarded by the worst soldiers the Union army had to offer. Only a man who had never been up close and personal with a bayonet would think that type of blade would leave such a fine scar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And only a man who had never had to fight for food and shelter would ever think a scar like the one on his neck could heal so quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Resentment boiled in him. How was it that he’d constantly had to fight and scrape to survive while men like Old Philly simply coasted through?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Furious, he turned to the man. “My scar sure ain’t from some blasted Yankee bayonet. If you had ever held one, you might even know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Philly’s smirk vanished abruptly. “What did you just say to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("“Watch your mouth, Sergeant,” Major Kelly muttered under his breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the warning came too late. His mouth had gotten the best of him yet again. And because he was sweaty and mosquito bitten, and there was little to no chance he’d ever escort a fine lady around any body of water in his lifetime, he let his temper fly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You heard me,” Thomas jeered. “I swear, every time you open your mouth, I have more respect for Yankees. No wonder they have you guarding a bunch of injured officers instead of fighting. You’d be worthless on the field. This scar is well on twelve years old.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Old Philly was now tromping toward him, passing the rest of the Confederate officers who had stopped working to watch his implosion with various degrees of regret and dismay. “What did you do to get sliced like that when you were a kid, then? Steal something?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, how he got his scar was something he never talked about. Only a masochist would revisit the night his brother and parents were killed. And while Thomas Travis Baker was a lot of things, he sure wasn’t the type to sit around and feel sorry for himself. “You need to stop talking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Old Philly stiffened and his eyes bugged out. He looked so fired up, he was about to turn purple. “Did you just tell me to stop talking?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did. But was that too difficult to understand?” he taunted. And while his brain was telling him to be quiet, his mouth—like always—couldn’t seem to listen. “Can you not understand simple words either?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Phillip Markham, Thomas’s lieutenant, cursed under his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pulling out handcuffs, Old Philly restrained Thomas’s hands. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("Then, with a rough pull and a shove, he marched him to the stocks by the barracks. “Five lashes for insubordination!” he called out.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thomas felt a shudder race up his spine. Yet again he’d gone too far.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clay and one other guard stepped forward, grabbed his wrists, and carted him toward the whipping post. As they jerked him forward and tied him to the six-foot pole, they didn’t seem to notice he wasn’t putting up a bit of protest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As other men gathered around and sweat poured off him, Thomas braced himself for the pain that was coming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tried to concentrate on the present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because even though it was a bad place to be, it was easier to bear than the dark, frantic thoughts filling his head. Easier than remembering the last thing his father told him before he pushed Thomas away and told him to hide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("For once in your life, do what you’re told without argument, Thomas. Go to the secret crawl space under the kitchen. Go there now. Do it, son! Crawl in there, and don’t come out. No matter what you hear, don’t come out.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To his everlasting shame, Thomas had done just that. He’d torn open the tender skin on his neck when it met a protruding nail as he crawled under the cabinet. It had bled for what felt like hours as he remained folded into a small ball in a dark hole in the ground. It bled as he heard his mother scream and his older brother beg for mercy. It bled as he heard his father being stabbed repeatedly. It bled as he heard men rummage through their house, steal their horses, and at last run off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time Thomas came out, the wound had clotted and the blood on his clothes had dried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he saw what his family had endured at the hands of the Comanche while he stayed hidden, Thomas had known one thing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("Never again would he follow instructions he didn’t agree with.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the first lash cut into his back, he welcomed the pain. Then he stared out at the water and imagined he was back in that rowboat with the sweet woman. Where everything was peaceful and lovely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It likely would never happen, but he allowed himself to dream.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df61433","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780718078218_Prologue.vue
// module id = 78
// module chunks = 0